import { WebDokuNodeValue } from './web-doku-node-value';

export class NodeValueTreeItem {
  public text = '';
  public nodes: NodeValueTreeItem[] = [];
  public values: WebDokuNodeValue[] = [];
}
